import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageService } from '../services/language.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  private readonly languageService = inject(LanguageService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (request.body instanceof FormData) {
      return next.handle(request);
    }

    request = request.clone({
      setHeaders: {
        'Accept-Language': 'en-US',
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
      },
    });
    return next.handle(request);
  }
}
